module.exports = __webpack_public_path__ + "static/media/sort-numeric-down-alt.97fc119f.svg";